"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const store_1 = require("../../../context/store");
const Warning_1 = __importDefault(require("./Warning"));
const styled_1 = require("./styled");
const generateUrl = (base, opts) => {
    const query = new URLSearchParams();
    if (opts.provider)
        query.append("provider", opts.provider);
    if (opts.type)
        query.append("type", opts.type);
    if (opts.crypto)
        query.append("crypto", opts.crypto);
    if (opts.amount)
        query.append("amount", opts.amount.toString());
    if (opts.address)
        query.append("address", opts.address);
    if (opts.fiat)
        query.append("fiat", opts.fiat);
    return `${base}?${query.toString()}`;
};
const ProviderQuote = ({ quote, provider, code, callback, buy }) => {
    const { selectedFiat, cryptoValue, address, providerPath } = (0, store_1.useTrackedState)();
    const outsideLimits = 
    // has limits
    quote.limits &&
        // and is less than min
        (quote.fiatAmount < quote.limits.min ||
            // or is more than max and max isn't unlimited
            (quote.fiatAmount > quote.limits.max && quote.limits.max !== -1));
    return (react_1.default.createElement(styled_1.Wrapper, Object.assign({ onClick: () => {
            callback(provider.id);
        } }, (providerPath
        ? {
            as: "a",
            href: generateUrl(providerPath, {
                provider: provider.id,
                type: buy ? "buy" : "sell",
                crypto: code,
                amount: buy ? quote.fiatAmount : cryptoValue,
                address,
                fiat: selectedFiat,
            }),
            target: "_blank",
            rel: "noreferrer",
        }
        : {})),
        react_1.default.createElement(styled_1.ProviderDetails, null,
            react_1.default.createElement(styled_1.Name, null,
                react_1.default.createElement("img", { src: provider.logo, alt: provider.name, height: 16, width: 16, style: { marginRight: 8 }, loading: "lazy" }),
                provider.name),
            quote.paymentOptions && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(styled_1.MethodsTitle, null,
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "buy.partner-payment-methods" })),
                react_1.default.createElement(styled_1.PaymentMethods, null, quote.paymentOptions.map((p) => (react_1.default.createElement("img", { key: p.id, src: p.icon, alt: p.id, height: 14, width: "auto" }))))))),
        react_1.default.createElement(styled_1.NoQuote, null,
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "buy.partner-no-quote" })),
        !quote.isRequestedCurrency && quote.cryptoAmount > -1 && (react_1.default.createElement(Warning_1.default, null,
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "buy.warning.unsupported-fiat", values: {
                    selectedFiat,
                    purchaseFiat: quote.fiatCode,
                } }))),
        quote.limits && outsideLimits && (react_1.default.createElement(Warning_1.default, null,
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "buy.warning.min-max", values: {
                    min: quote.limits.min.toLocaleString(),
                    max: quote.limits.max === -1
                        ? "∞"
                        : quote.limits.max.toLocaleString(),
                    fiatCode: quote.fiatCode,
                } })))));
};
exports.default = ProviderQuote;
//# sourceMappingURL=ProviderQuote.js.map